// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OIqh","delete":"styles_delete__S3Exe","update":"styles_update__ePHuK","add":"styles_add__22762"};